module.exports = __webpack_public_path__ + "assets/img/intro-normal-2.4f8ba20e.jpg";